module.exports = __webpack_public_path__ + "img/Logo-30.c9183c46.svg";